export default __webpack_public_path__ + "static/media/deauville18.dbf57af8.jpg";